
//第一页面
export const getMonthFrom = (state, monthFrom) => {
    state.monthFrom = monthFrom;
};
export const getMonthTo = (state, monthTo) => {
    state.monthTo = monthTo;
};
export const getBrand = (state, Brand) => {
    state.Brand = Brand;
};
export const getCateGory1 = (state, CateGory1) => {
    state.CateGory1 = CateGory1;
};
export const getCateGory2 = (state, CateGory2) => {
    state.CateGory2 = CateGory2;
};

export const getFlag = (state, MyFlag) => {
    state.MyFlag = MyFlag;
};
//第二页面
export const getComFlag = (state, ComMyFlag) => {
    state.ComMyFlag = ComMyFlag;
};
export const getComMonthFrom = (state, ComMonthFrom) => {
    state.ComMonthFrom = ComMonthFrom;
}; 
export const getComMonthTo = (state, ComMonthTo) => {
    state.ComMonthTo = ComMonthTo;
}; 
export const getComBrand = (state, ComBrand) => {
    state.ComBrand = ComBrand;
}; 
export const getComCateGory2 = (state, ComCateGory2) => {
    state.ComCateGory2 = ComCateGory2;
}; 
export const getComCateGory3 = (state, ComCateGory3) => {
    state.ComCateGory3 = ComCateGory3;
}; 
export const getComCateGory1 = (state, ComCateGory1) => {
    state.ComCateGory1 = ComCateGory1;
}; 
export const getPlatForm = (state, PlatForm) => {
    state.PlatForm = PlatForm;
};
//第三页面
export const getCouMonthFrom = (state, CoumonthFrom) => {
    state.CoumonthFrom = CoumonthFrom;
};
export const getCouMonthTo = (state, CoumonthTo) => {
    state.CoumonthTo = CoumonthTo;
};
export const getCouBrand = (state, CouBrand) => {
    state.CouBrand = CouBrand;
};
export const getCouCateGory1 = (state, CouCateGory1) => {
    state.CouCateGory1 = CouCateGory1;
};
export const getCouCateGory2 = (state, CouCateGory2) => {
    state.CouCateGory2 = CouCateGory2;
};



// WEBPACK FOOTER //
// ./src/store/mutations.js